<template>
    <div class="tag-container">
        <div class="tag-input mb-2">
            <div class="input-group">
                <InputText
                    type="text"
                    :placeholder="placeholder"
                    :disabled="disabled"
                    v-model="inputValue"
                    @keydown:enter="addTag"
                    @keydown:backspace="inputValue === '' ? removeTag(modelValue.length - 1) : null"
                />
                <div class="input-group-append" v-if="hideTagsCount.length > 0">
                    <Button size="sm" color="light" @click="showAllTags = !showAllTags" >
                        <i :class="{'icon-arrow-down12' : true, 'rotate-180' : showAllTags, 'mr-2': true}"></i>
                        <span>{{ hideTagsCount.length }}</span>
                    </Button>
                </div>
                <AlphaButton color="danger" class="ml-2" @click="removeAllTags" :disabled="tags.length === 0">
                    <i class="icon-trash"></i>
                </AlphaButton>
                <AlphaButton color="primary" class="ml-2" @click="copyAllTags" :disabled="tags.length === 0">
                    <i :class="copied ? 'icon-file-check' : 'icon-file-empty'"></i>
                </AlphaButton>
            </div>
        </div>
        <div :class="{'bootstrap-tagsinput': true, 'disabled': disabled}">
            <slot v-for="(tag, index) in tags">
                <span
                    v-if="showAllTags || (index + 1 <= showCountTags)"
                    :class="[
                        'tag label label-info',
                        disabledReasonByTag[tag] && 'disabled-tag'
                    ]"
                >
                    {{ disabledReasonByTag[tag] 
                        ? `${tag} (${disabledReasonByTag[tag]})`
                        : tag
                    }}
                    <span
                        v-if="!disabledReasonByTag[tag]"
                        data-role="remove"
                        @click="disabled ? null : removeTag(index)"
                    ></span>
                </span>
            </slot>
        </div>
    </div>
</template>
<script>
import InputText from "../../new/form/Input.vue";
import Button from "../../new/button/AppButton.vue";
import AlphaButton from "../../new/button/AlphaButton.vue";

export default {
    name: "Tags",
    components: {InputText, Button, AlphaButton},
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        unique: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: () => translate('components.tags.placeholder')
        },
        disabled: {
            type: Boolean,
            default: false
        },
        disabledTags: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            inputValue: '',
            showAllTags: false,
            showCountTags: 15,
            copied: false
        }
    },
    methods: {
        addTag() {
            let newTags = this.tags;
            if (this.inputValue === '') {
                return;
            }

            if (this.unique) {
                this.inputValue.split(',').forEach(tag => {
                    if (!newTags.includes(tag) && tag !== '') {
                        newTags.push(tag)
                    }
                })
            } else {
                newTags = this.inputValue.split(',').forEach(tag => {
                    if (tag !== '') {
                        newTags.push(tag)
                    }
                })
            }

            this.tags = newTags;
            this.inputValue = '';
            this.copied = false;
        },
        removeTag(index) {
            let newTags = this.tags.filter((tag, i) => i !== index);
            this.tags = newTags;
            this.copied = false;
        },
        removeAllTags() {
            this.tags = [];
            this.copied = false;
        },
        async copyAllTags() {
            await navigator.clipboard.writeText(this.modelValue);
            
            this.copied = true;
        }
    },
    computed: {
        tags: {
            get() {
                if (!this.modelValue && this.disabledTags.length === 0) {
                    return [];
                }

                let tagsArray = this.modelValue ? this.modelValue.split(', ') : [];

                this.disabledTags.forEach(({tag, reason}) => {
                    if (tagsArray.includes(tag)) {
                        return
                    }

                    tagsArray.push(tag)
                })

                return tagsArray.sort((a, b) => a.localeCompare(b));
            },
            set(newTags) {
                newTags = newTags.filter((tag) => !Object.keys(this.disabledReasonByTag).includes(tag))

                this.$emit('update:modelValue', newTags.join(', '));
            }
        },
        hideTagsCount() {
            if (!this.modelValue) {
                return [];
            }

            let tagsArray = this.modelValue.split(', '),
                sortedTags = tagsArray.sort((a, b) => a.localeCompare(b));

            return sortedTags.slice(this.showCountTags);
        },
        disabledReasonByTag() {
            return this.disabledTags.reduce((acc, {tag, reason}) => {
                acc[tag] = reason

                return acc
            }, {})
        }
    }
}
</script>
<style scoped>
.bootstrap-tagsinput {
    display: flex;
    align-items: center;
    white-space: nowrap;
    flex-wrap: wrap;
    border-width: 1px 0px;
    border-top-color: transparent !important;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.bootstrap-tagsinput.disabled > .tag {
    opacity: 0.5;
}

.bootstrap-tagsinput.disabled > .tag:hover {
    background-color: #eeeded;
    color: #333;
    opacity: 0.5;
}

.bootstrap-tagsinput.disabled > .tag:hover [data-role="remove"] {
    cursor: default;
    opacity: 0.7;
    transition: none;
}

.bootstrap-tagsinput.focus {
    outline: 0;
    border-color: #009688;
    box-shadow: 0 0 0 0 transparent, 0 1px 0 #009688;
}

.bootstrap-tagsinput input {
    margin: 0;
}

.bootstrap-tagsinput .tag{
    padding: 5px 10px;
    padding-right: 35px;
    margin: 3px 10px 3px 0px;
}

.disabled-tag {
    opacity: 0.5;
    padding-right: 10px !important;
}
</style>
